import * as React from "react";
import {
  NotificationContainer,
  Notification as UINotification,
  type NotificationProps,
} from "@emisgroup/ui-notification";
import { ToastVariant } from "./Types";
import { CloseIcon } from "./CloseIcon";
import InfoConfirm from "~icons/ic/baseline-check-circle";
import InfoError from "~icons/ic/outline-do-not-disturb-on";
import InfoNotification from "~icons/ic/baseline-info";
import "./Style.scss";

export interface UINotificationProps extends NotificationProps {
  /**
    * The text for the notification
  */
  text: React.ReactNode;
  /**
    * The type of notification
  */
  variant: ToastVariant;
  /**
    * Whenever the notification is closable
  */
  closable?: boolean;
}

export const Notification = ({ title, text, variant, closable, ...rest }: UINotificationProps): JSX.Element => {
  /**
     * Get the notification type as string
     * @param type The type of notification
     * @returns The notification type as a lowercase string
     */
  const getNotificationTypeText = (type: ToastVariant): string => {
    return type.toString().toLowerCase();
  };

  /**
     * Get the notification icon
     * @param type The type of notification
     * @returns The notification icon
     */
  const getNotificationIcon = (type: ToastVariant): JSX.Element => {
    if (type === "success") {
      return <InfoConfirm title="success" />;
    }

    if (type === "error") {
      return <InfoError title="Error" />;
    }

    return <InfoNotification title="Information" />;
  };

  const content = title ? (
    <div className={`eb-notification_content__${variant}`}>
      <b>{title}</b> {text}
    </div>
  ) : <div>{text}</div>;

  const closeContent =  closable ? (
    <div onClick={rest.onClose} className="eb-notification__close-container">
      <CloseIcon/>
    </div>
  ) : null;

  return (
    <NotificationContainer>
      <UINotification
        className="eb-notification_content__container"
        data-type={getNotificationTypeText(variant)}
        {...rest}>
        <UINotification.Content>
          <div className="eb-notification_content">
            <div className="eb-notification__icon">
              {getNotificationIcon(variant)}
            </div>
            {content}
            {closeContent}
          </div>
        </UINotification.Content>
      </UINotification>
    </NotificationContainer>
  );
};
